import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { ModalComponent } from "../../../components/Modal/ModalComponent/ModalComponent";
import './ModalConfirmIgnoreTnved.scss'

const ModalConfirmIgnoreTnved = ({
    setIsModal,
    setIgnoreTnved,
    isEdit
}) => {

    return (
        <ModalComponent
            title="Не указан атрибут ТН ВЭД"
            onClose={e => setIsModal(false)}
            style={{
                maxWidth: '500px',
                height: 'auto'
            }}
            child={
                    <div className='modal-confirm-ignore-tnved'>
                            <ButtonBasic
                                grey
                                text='Продолжить редактирование'
                                width='100%'
                                onClick={(e) => setIsModal(false)}
                            />

                            <ButtonBasic
                                text={`${isEdit ? 'Обновить' : 'Создать'} товар без ТН ВЭД`}
                                width='100%'
                                onClick={(e) => {
                                    setIgnoreTnved(true)
                                    setIsModal(false)
                                }}
                            />
                    </div>
            }
        />
    )
}

export { ModalConfirmIgnoreTnved }